import moment from 'moment'

export const setTicketSearchHistory = (lastSearch) => {
  lastSearch.timestamp = moment().toISOString()

  // note: putting in array in case we want to store more later
  const histories = [lastSearch]

  localStorage.setItem('r2r.ticketSearchHistory', JSON.stringify(histories))
}
